var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top" } },
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "innerWrapper" }, [
      _c("h1", [_vm._v("Terms and Conditions")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      This Website and its contents are owned or licensed by Unifi Property\n      Pty Ltd (ACN 638 376 977) ("
        ),
        _c("span", { staticClass: "bold" }, [_vm._v("Unifi, we, us")]),
        _vm._v(" or\n      "),
        _c("span", { staticClass: "bold" }, [_vm._v("our")]),
        _vm._v(").\n    ")
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("AGREEMENT TO TERMS AND CONDITIONS")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      To the maximum extent permitted by law, these terms and conditions\n      govern the use of this Website, the placement of any Reservations and\n      the purchase of any Services via this Website. We may amend these Terms\n      and Conditions from time to time and if any part of them is illegal or\n      unenforceable at law, it may be severed and the remaining Terms and\n      Conditions will continue in full force and effect.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("AMENDMENTS TO THESE TERMS AND CONDITIONS")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      For future orders of our Services and Reservations that You place with\n      us, these Terms and Conditions may be different. We recommend that you\n      read these Terms and Conditions carefully each time You visit our\n      Website, order our Services or place a Reservation. We will not change\n      any Terms and Conditions for an existing Services order or a Reservation\n      that we have accepted; the Terms and Conditions that will apply to the\n      Reservation or Service are the Terms and Conditions that applied at the\n      time You placed the Reservation or ordered the Service.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("DEFINITIONS")]),
      _vm._v(" "),
      _c("h2", [_vm._v("In these Terms and Conditions:")]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Available Properties")]),
        _vm._v(
          " means residential or\n      commercial properties offered for sale Prospective Property Purchasers\n      by Varo Property Services or its Co-Agents, as agents of the registered\n      proprietors of those properties.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Claim")]),
        _vm._v(
          " means any claim, action, proceeding,\n      loss, damage, suit, cause of action, demand, cost, expense or liability,\n      brought, made or recovered against a person, howsoever arising, whether:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(" in contract, tort or otherwise; or")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          " presently ascertained, immediate, future\n      or contingent.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Co-Agent")]),
        _vm._v(
          " means a third party agent who has\n      been appointed to sell or otherwise deal with an Available Property on\n      behalf of the registered proprietor.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Commercialise")]),
        _vm._v(
          " in relation to Intellectual\n      Property Rights, means to:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "manufacture, sell, hire or otherwise\n      exploit a product or process, that incorporates any of the Intellectual\n      Property Rights;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "provide a service using any of those\n      Intellectual Property Rights;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "license any third party to do any of those\n      things,\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("regardless of whether any revenue is generated.")]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [
          _vm._v("Confidential Informatio")
        ]),
        _vm._v(
          " means information\n      concerning Unifi or any of its Related Bodies Corporate (including Varo\n      Property Services), including details of:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "any past, current or prospective purchasers\n      of residential or commercial properties;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v("any suppliers, contractors or agents;\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "business dealings, methodologies, marketing\n      techniques or market analysis;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(d)")]),
        _vm._v(
          "financial arrangements with purchasers,\n      suppliers, contractors or agents;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(e)")]),
        _vm._v(
          "information disclosed on the Property\n      Platform; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(f)")]),
        _vm._v(
          "any other information that is by its nature\n      confidential, is reasonably designated by Unifi as confidential or which\n      You know or ought to know is confidential,\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bigindent" }, [
        _c("h2", [_vm._v("but does not include information:")]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(i)")]),
          _vm._v(
            "in the public domain, unless it came into\n        the public domain due to a breach of these Terms and Conditions or\n        some other obligation of confidentiality;\n      "
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(ii)")]),
          _vm._v(
            "that is already lawfully in Your\n        possession without restriction, before it was disclosed by Unifi; or\n      "
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(iii)")]),
          _vm._v(
            "that You obtained lawfully from a third\n        party, without any breach of confidentiality.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("GST")]),
        _vm._v(
          " means the tax payable on taxable supplies\n      under the\n      "
        ),
        _c("span", { staticClass: "souwai" }, [
          _vm._v("A New Tax System (Goods and Services Tax) Act 1999")
        ]),
        _vm._v("\n      (Cth), including any subordinate legislation.\n    ")
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [
          _vm._v("Intellectual Property Rights")
        ]),
        _vm._v(
          " means all\n      industrial and intellectual property rights anywhere in the world,\n      whether registered or unregistered, including patent rights, trade mark\n      rights, copyright (but excluding Moral Rights), plant breeders' rights\n      and rights in relation to inventions, trade names, business names,\n      company names, indications of origin, designs, plant varieties,\n      semiconductors, circuit layouts, confidential information or know-how,\n      any right of registration, renewal and extension of such rights and all\n      other intellectual property as defined in article 2 of the\n      "
        ),
        _c("span", { staticClass: "souwai" }, [
          _vm._v(
            "Convention Establishing the World Intellectual Property Organisation\n        1967"
          )
        ]),
        _vm._v(".\n    ")
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Moral Rights")]),
        _vm._v(" means moral rights as described\n      in Part IX of the "),
        _c("span", { staticClass: "souwai" }, [_vm._v("Copyright Act 1968")]),
        _vm._v(
          "\n      (Cth) and any analogous rights arising under statute that exist, or may\n      come to exist, anywhere in the world.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Personal Information")]),
        _vm._v(
          " means information or an\n      opinion about an identified individual, or information from which an\n      individual could reasonably be identified. This is regardless of whether\n      the information or opinion is true, and whether or not it is stored in a\n      material or intangible form.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Privacy Policy")]),
        _vm._v(
          " means the privacy policy of\n      Unifi as displayed on this Website from time to time.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Property Platform")]),
        _vm._v(
          "means the electronic platform\n      which allows Referral Partners with a valid Referral Account to access\n      information on Available Properties, including:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v("purchase prices;")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v("dimensions, land size and floor plans; and\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v("a description of the Available Property\n      features.\n    ")
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [
          _vm._v("Prospective Property Purchaser")
        ]),
        _vm._v(
          " means an\n      individual or entity interested in obtaining details of the Available\n      Properties, with a view to a possible purchase of one or more of them.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Referral Account")]),
        _vm._v(" means an online record of\n      information:\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v("created by a Referral Partner;")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "containing the company name, Australian\n      Business Number, street or PO Box address, email address and telephone\n      number of the Referral Partner; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "which permits the Referral Partner to\n      access details of Available Properties and to place orders for Services.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Referral Partner")]),
        _vm._v(
          " means a third party that may\n      refer Prospective Property Purchasers to Varo Property Services or its\n      Co-Agent.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [
          _vm._v("Related Bodies Corporate")
        ]),
        _vm._v(" has the same meaning\n      as set out in the\n      "),
        _c("span", { staticClass: "souwai" }, [
          _vm._v("Corporations Act 2001")
        ]),
        _vm._v(" (Cth).\n    ")
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Reservation")]),
        _vm._v(
          " means an agreement formed upon\n      processing of the Reservation Fee, under which a Prospective Property\n      Purchaser reserves an Available Property from viewing by other Referral\n      Partners on the Property Platform, for the Reservation Period.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Reservation Fee")]),
        _vm._v(
          " means the fee paid by or on\n      behalf of a Prospective Property Purchaser to secure a Reservation.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Reservation Period")]),
        _vm._v(
          " means a period of seven (7)\n      days from the payment of the Reservation Fee, or such longer period as\n      may be agreed between You and Unifi.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Services")]),
        _vm._v(" means any of:")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v("a Reservation;")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "training materials, modules or activities\n      accessible from our Website from time to time; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "(c)any other services which may be\n      purchased or made available from this Website from time to time.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Terms and Conditions")]),
        _vm._v(
          " means these terms and\n      conditions as may be amended from time to time.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Third Party Fees")]),
        _vm._v(
          " means the fees described in\n      paragraph (f) of the PLACEMENT OF RESERVATIONS AND PURCHASE OF OTHER\n      SERVICES FROM OUR WEBSITE section of these Terms and Conditions.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Varo Property Services")]),
        _vm._v(
          " means Varo Property\n      Services Pty Ltd ACN 140 366 543.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("Website")]),
        _vm._v(" means the website situated at ["),
        _c("span", { staticClass: "red" }, [_vm._v("insert website address")]),
        _vm._v("] and includes the Property Platform.\n    ")
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("You")]),
        _vm._v(
          " means any of a Referral Partner or other\n      third party that accesses our Website, as the context requires and\n      "
        ),
        _c("span", { staticClass: "bold" }, [_vm._v("Your")]),
        _vm._v(" or "),
        _c("span", { staticClass: "bold" }, [_vm._v("Yourself")]),
        _vm._v(" has\n      a corresponding meaning.\n    ")
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("USE OF THIS WEBSITE")]),
      _vm._v(" "),
      _c("h2", [_vm._v("You may only use this Website if You:")]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v("have a valid Referral Account;")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v("are aged 18 years or over;")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "are authorised by Prospective Property\n      Purchasers to create a Reservation of Available Properties on their\n      behalf; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(d)")]),
        _vm._v(
          "agree to be bound by, and accept, these\n      Terms and Conditions.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Please immediately exit this Website if You do not satisfy these\n      requirements.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n      PLACEMENT OF RESERVATIONS AND PURCHASE OF OTHER SERVICES FROM OUR\n      WEBSITE\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("You agree that:")]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "both You and any Prospective Property\n      Purchaser for whom you act are aged 18 years or over;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "if You place a Reservation or an order for\n      Services on our Website, You enter into a contract with Unifi for the\n      supply of the Reservation or those Services. Each accepted order is a\n      separate contract;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "we can accept or reject a Reservation or\n      order for Services for reasons which include unavailability of the\n      Available Properties or Services (as the case may be), an error in the\n      pricing or description of the Available Properties or Services, or an\n      error in Your Reservation or order for the Services;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [_c("span", { staticClass: "word" }, [_vm._v("(d)")])]),
      _vm._v(" "),
      _c("div", { staticClass: "bigindent" }, [
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(i)")]),
          _vm._v("creating a Referral Account;")
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(ii)")]),
          _vm._v("placing a Reservation; or")
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(iii)")]),
          _vm._v("ordering any Services,")
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "\n        must be accurate, complete and up to date, and You will promptly\n        notify us of any changes to this information or data;\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(e)")]),
        _vm._v(
          "all prices quoted for the Reservation Fee\n      or Services are displayed in Australian Dollars (AUD) and are inclusive\n      of GST;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(f)")]),
        _vm._v(
          "once You have placed Your Reservation or\n      order for Services, You may effect payment by either Mastercard or Visa.\n      We will send You a tax invoice / receipt to Your nominated email address\n      when Your payment has been processed. Please note that by using the\n      payment facilities provided by third party e-commerce facilities or\n      credit card merchants, You will be subject to additional terms,\n      conditions, fees and charges imposed by those third parties;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(g)")]),
        _vm._v(
          "the payment system on this Website uses\n      industry standard Secure Socket Layer (SSL) technology to encrypt and\n      protect Your credit card details ["
        ),
        _c("span", { staticClass: "red" }, [
          _vm._v("TO BE CONFIRMED WITH ELECTRONIC PAYMENT GATEWAY PROVIDER")
        ]),
        _vm._v("];\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(h)")]),
        _vm._v(
          "we will provide Your Reservation or\n      Services after Your payment has been processed. For the avoidance of\n      doubt, we do not offer for sale, or sell Available Properties, but\n      simply make them available for viewing on our Property Platform;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(i)")]),
        _vm._v(
          "we will use our reasonable endeavours to\n      ensure that Available Properties are available for purchase or Services\n      are available for delivery, and in most cases will notify You if\n      Available Properties are no longer available before You place Your\n      Reservation, or Services are unavailable before You order them. In some\n      cases, this will not be possible and we will need to reject a\n      Reservation for Available Properties or an order for Services after we\n      have processed Your payment. In these cases, we will refund You in full\n      all amounts You have paid for the Reservation or unavailable Services,\n      less the Third Party Fees;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(j)")]),
        _vm._v(
          "if you cancel Your Reservation before the\n      Reservation Period expires, we will refund the Reservation Fee to You,\n      less the Third Party Fees;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(k)")]),
        _vm._v(
          "if You or a Prospective Property Purchaser\n      executes a contract for the sale of land with the registered proprietor\n      of an Available Property, the Reservation Fee will be applied in part\n      payment of the purchase price; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(l)")]),
        _vm._v(
          "once the Services have been delivered, You\n      assume all risk and title in the Services.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("YOUR REFERRAL ACCOUNT")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      When placing Reservations or purchasing Services via this Website, You\n      will need to create a Referral Account with us.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("To create a Referral Account, You must:")]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "be aged 18 years or over and have the\n      capacity to enter into a binding legal agreement to create a Referral\n      Account with us;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "provide us with, amongst other matters,\n      Your company name, Australian Business Number, street or PO Box address,\n      email address and telephone number. All Personal Information that we\n      receive from You is handled in accordance with the practices set out in\n      our Privacy Policy which is accessible from this Website; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "create a password and username at the time\n      that You register a Referral Account with us. You are responsible for\n      maintaining the security of Your username and password. If You suspect\n      that Your account has been subject to unauthorised access, You must\n      contact us immediately and take reasonable steps to secure Your account,\n      such as changing Your password. We are not liable for any Claims\n      howsoever arising from the unauthorised use of Your password or\n      username.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We reserve the right to terminate or suspend Your account in the event\n      that you breach these Terms and Conditions.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("YOUR PERSONAL INFORMATION AND PRIVACY")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("\n      Our Privacy Policy ["),
        _c("span", { staticClass: "red" }, [_vm._v("insert link")]),
        _vm._v(
          "] sets out the\n      ways in which we may collect, store, use and manage Your Personal\n      Information, and the physical and electronic measures we will take to\n      protect Your Personal Information.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      By supplying us with Personal Information through this Website, You\n      accept the inherent security risk of dealings online over the internet\n      and agree not to hold us responsible for any breach of security, unless\n      we have breached a law or been in wilful default of our duties to You.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("OUR INTELLECTUAL PROPERTY RIGHTS")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Unless expressly stated otherwise, we own or are licensed to use all\n      Intellectual Property Rights in this Website and its content. You may\n      only use that content with our express written consent or as permitted\n      under applicable Australian and international laws. If we allow You to\n      use any of the content appearing on this Website, our status as the\n      owner or licensee of the Intellectual Property Rights in that content\n      must be publicly acknowledged in writing, as we may direct. In that\n      respect, You must not:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "adapt, modify, reproduce or transmit any of\n      the Website content (including its graphics, layouts and format) without\n      our prior written consent;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "frame our Website content within Your own\n      website, without our prior written consent;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "download our Website content for any\n      purpose other than referring Prospective Property Purchasers to Varo\n      Property Services or its Co-Agent.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We do not own or license, and we take no responsibility for trade marks,\n      logos, design and copyright material appearing in:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "any third party websites which may be\n      accessible from links displayed on our Website; or\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v("content that You provide to us.")
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("CONFIDENTIAL INFORMATION")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Some sections of this Website, including the Property Platform, contain\n      Confidential Information. By accessing this Website, You acknowledge and\n      agree that:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "(a)we are providing You with access to the\n      Confidential Information to facilitate Your referral of Prospective\n      Property Purchasers to Varo Property Services or its Co-Agents;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "You will not use or disclose the\n      Confidential Information for any other purpose, including to:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bigindent" }, [
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(i)")]),
          _vm._v(
            "improperly gain an advantage for Yourself\n        or someone else;\n      "
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(ii)")]),
          _vm._v(
            "cause detriment to Unifi, Varo Property\n        Services or its Co-Agent;\n      "
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(iii)")]),
          _vm._v(
            "solicit, canvass or approach any of the\n        registered proprietors of the Available Properties, so as to induce\n        them to cease the appointment of Varo Property Services or its\n        Co-Agent;\n      "
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(iv)")]),
          _vm._v(
            "interfere with the relationship between\n        registered proprietors of the Available Properties and Varo Property\n        Services or its Co-Agent; and\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "the restrictions and prohibitions outlined\n      in this section are reasonable in the circumstances and necessary to\n      protect the goodwill in Unifi's, Varo Property Services' and its\n      Co-Agent's business; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(d)")]),
        _vm._v(
          "(d)monetary damages alone are not an\n      adequate remedy for breach of this section and Unifi may apply for\n      injunctive relief if You breach or threaten to breach this section.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("CONTENT WE PROVIDE")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Unless stated otherwise, we grant to You a personal, non-transferable,\n      revocable and non-exclusive licence to use any files that we expressly\n      state is available for download on this Website, for Your own personal\n      use. Unless permitted by a written agreement between You and us, You\n      must not copy, communicate to the public, modify, reverse engineer, or\n      otherwise transfer any right in those files.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We cannot guarantee that information (including any file) obtained from\n      this Website is free from computer viruses, other faults or defects. It\n      is Your responsibility to scan the information for computer viruses and\n      You assume the risk of any damage to Your computer and associated\n      equipment arising from the use of this Website or the downloading of any\n      files from it.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("CONTENT YOU PROVIDE")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      You are fully responsible for any content (including any testimonials,\n      comments, suggestions, graphics or other material) that You provide to\n      us for display on the Website. By providing content to us, You grant us\n      a licence to use that content without payment or reference to You, for\n      purposes which include advertising or marketing our own business and\n      services.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      You agree that You will not use this Website to post or display content\n      that:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v("You do not have the right to post or\n      display;\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "violates the Intellectual Property Rights,\n      confidentiality, privacy or other rights of any person or entity;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "violates consumer protection or fair\n      trading laws;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(d)")]),
        _vm._v(
          "is offensive, abusive, defamatory,\n      discriminatory, false or misleading;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(e)")]),
        _vm._v(
          "comprises advertising or promotional\n      materials of any kind; or\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(f)")]),
        _vm._v(
          "contains software viruses or anything\n      harmful to this Website or to the computers, mobile devices or\n      associated equipment of other users of this Website.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We reserve the right to edit or remove any of Your content at any time,\n      without providing any reasons.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("LINKS TO EXTERNAL WEBSITES")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Our Website may contain links to Websites or advertisements of goods and\n      services available from third parties. We are not responsible for the\n      content of those Websites or advertisements, or any goods or services\n      made available on them.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("SOCIAL MEDIA")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("\n      We maintain a presence on\n      "),
        _c("span", { staticClass: "souwai" }, [
          _vm._v("Facebook, Instagram, LinkedIn and Twitter")
        ]),
        _vm._v(
          "\n      but are not endorsed by, or affiliated with, those organisations ("
        ),
        _c("span", { staticClass: "bold" }, [_vm._v("Social Media Accounts")]),
        _vm._v(
          "). We reserve the right to remove any material that is posted on the\n      pages of our Social Media Accounts that:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "is abusive, defamatory, offensive or\n      threatening towards us, our employees or any other person or\n      organisation;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "breaches the terms and conditions of any of\n      the providers of the Social Media Accounts;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "constitutes spruiking or other advertising,\n      unless written consent has been obtained from us to post such material;\n      or\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(d)")]),
        _vm._v("relates to any illegal activity.")
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Please note that You will be subject to, and agree to comply with, the\n      respective terms and conditions imposed by\n      "
        ),
        _c("span", { staticClass: "souwai" }, [
          _vm._v("Facebook, Instagram, LinkedIn")
        ]),
        _vm._v(
          " and Twitter\n      whilst You are visiting any of our Social Media Accounts and it remains\n      Your responsibility to familiarise Yourself with those terms and\n      conditions.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "bold" }, [_vm._v("[")]),
        _c("span", { staticClass: "red bold" }, [
          _vm._v("Our Website contains an embedded Twitter timeline of all:")
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "word red bold" }, [_vm._v("(a)")]),
        _c("span", { staticClass: "red bold" }, [_vm._v("[insert]; and")])
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "word red bold" }, [_vm._v("(b)")]),
        _c("span", { staticClass: "red bold" }, [
          _vm._v("re-tweets of Twitter users who reference @[insert].")
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "red bold" }, [
          _vm._v(
            "By embedding a Twitter timeline on our Website, Twitter is granted a\n        non-exclusive, royalty free licence to access, index and cache this\n        Website by any means, including web spiders and/or crawlers.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "red bold" }, [
          _vm._v(
            "Twitter's use of cookies may involve the storing and accessing of\n        cookies or other information on Your devices, as described in\n        Twitter's Cookie Use Policy. You should consider Twitter's Cookies Use\n        Policy before using our Website, which can be viewed via:\n        https://help.twitter.com/en/rules-and-policies/twitter-cookies"
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "red bold" }, [
          _vm._v(
            "Twitter's use of cookies may result in Twitter collecting and storing\n        data about Your browsing activities, including for interest based\n        advertising. By proceeding to use our Website, You consent to\n        Twitter's use of cookies. You may opt out of Twitter's interest-based\n        advertising and personalisation in accordance with the instructions\n        contained in its Twitter for Websites — ads info and privacy document,\n        accessible via:\n        https://help.twitter.com/en/twitter-for-Websites-ads-info-and-privacy"
          )
        ]),
        _c("span", { staticClass: "bold" }),
        _vm._v("]\n    ")
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("LIMITATION OF LIABILITY")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      To the maximum extent permitted by law, including the Australian\n      Consumer Law:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(a)")]),
        _vm._v(
          "we provide this Website on an “as is”\n      basis. We may suspend access to our Website or close it indefinitely\n      without notice and You accept the inherent security and reliability\n      risks of dealings on the internet;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(b)")]),
        _vm._v(
          "we are not liable for loss of revenue, loss\n      of actual or anticipated profits, loss of business or indirect and\n      consequential losses;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(c)")]),
        _vm._v(
          "we are not liable for a breach of our\n      obligations under these Terms and Conditions which has resulted from\n      causes beyond our reasonable control. Those causes include extreme\n      weather conditions, government restrictions, declared epidemics or\n      pandemics, industrial strikes and failure of equipment or machinery,\n      including failure of the internet; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "word" }, [_vm._v("(d)")]),
        _vm._v(
          "subject to the Australian Consumer Law (and\n      without excluding any mandatory statutory guarantees contained within\n      the Australian Consumer Law or other statutory rights which cannot be\n      excluded by contract) all conditions, warranties and implied terms are\n      excluded from these Terms and Conditions. To the extent that we breach\n      these Terms and Conditions and it is legally permissible to do so, our\n      liability is limited to:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bigindent" }, [
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(i)")]),
          _vm._v(
            "replacement of the Services supplied or\n        supply of equivalent Services;\n      "
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(ii)")]),
          _vm._v(
            "payment of the cost of replacing the\n        Services or acquiring equivalent Services;\n      "
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(iii)")]),
          _vm._v("supply of the Services again; or")
        ]),
        _vm._v(" "),
        _c("h4", [
          _c("span", { staticClass: "word" }, [_vm._v("(iv)")]),
          _vm._v(
            "in the case of Reservations, a refund of\n        the Reservation Fee, less the Third Party Fees.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We will take all reasonable steps to ensure that this Website is\n      accurate, but make no representation as to the appropriateness of it for\n      Your personal circumstances.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("NOTICES")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We may give notice to You by electronic mail or by regular mail to the\n      address contained in Your Referral Account or other information You have\n      provided. Our  Privacy Policy explains how You can opt-out of receiving\n      such notices.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("GOVERNING LAW")]),
      _vm._v(" "),
      _c("h2", { staticStyle: { "margin-bottom": "80px" } }, [
        _vm._v(
          "\n      The laws of South Australia, Australia, govern these Terms and\n      Conditions and the courts of South Australia have non-exclusive\n      jurisdiction to hear any matters arising from or in connection with\n      these Terms and Conditions.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-295c0c06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295c0c06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/more/term.vue
// module id = null
// module chunks = 